/**
 * Account Entry Point
 *
 * Mounts the AccountDashboard component on the account page.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ShopProvider } from '@/context';
import { AccountDashboard } from '@/components/Account';

const container = document.getElementById('evcs-account');

if (container) {
  const root = createRoot(container);
  root.render(
    <StrictMode>
      <ShopProvider>
        <AccountDashboard />
      </ShopProvider>
    </StrictMode>
  );
}
